import FilterListIcon from '@mui/icons-material/FilterList';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ListItem } from '../../../../sic-lib/types/Lists';
import { useAppSelector } from '../../../../store/hooks';
import DrawerConversationGridFiltersRaw from './DrawerConversationGridFiltersRaw/DrawerConversationGridFiltersRaw';

const useStyles = makeStyles()({
    button: {
        padding: '10px',
    },
});

type Props = {
    list: ListItem;
};

export default function DrawerConversationGridFilters({ list }: Props) {
    const { classes } = useStyles();

    const appliedFilters = useAppSelector(state => {
        return state.conversationGrid?.filters || [];
    });

    const [drawerId] = React.useState<string>('drawer_grid_filters');

    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <React.Fragment>
            <Tooltip title="Filters">
                <IconButton
                    aria-haspopup={true}
                    aria-controls={drawerId}
                    aria-expanded={isOpen}
                    onClick={handleOpen}
                    className={classes.button}
                    color={appliedFilters.length > 0 ? 'secondary' : 'default'}
                    size="large"
                >
                    <FilterListIcon />
                </IconButton>
            </Tooltip>
            <DrawerConversationGridFiltersRaw
                drawerId={drawerId}
                isOpen={isOpen}
                onCloseHandler={handleClose}
                list={list}
            />
        </React.Fragment>
    );
}
